module.exports = __webpack_public_path__ + "static/media/chevron-right-black.fab593f0.svg";